module.exports = __webpack_public_path__ + "static/media/old website.9e0ebb9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/Teafloor/old website.png
// module id = 366
// module chunks = 0